import React, {Fragment} from 'react';
import {IconButton,Grid, Table, TableHead,TableBody, TableRow, TableCell} from '@material-ui/core';
import {MoreVert} from '@material-ui/icons';
import _ from 'lodash'
import { withStyles } from "@material-ui/core/styles";
import styled from 'styled-components';
import numeral from 'numeral';
import { connect } from 'formik';
import { connect as reduxConnect } from "react-redux";
import { compose} from "redux";
import AddButton from 'components/Global/Buttons/AddButton';
import OptionsMenu from "components/Global/OptionsMenu/OptionsMenu";
import SimpleConfirmDialog from 'components/Global/ConfirmationDialogs/SimpleConfirmDialog';
import ContactInformationModalForm from './ContactInformationModalForm/ContactInformationModalForm';
import {exportLoanContacts} from 'store/state/loan/loanContacts';
import {
  ChildSectionTitle,
  SideLabelTextWithRefInput,
} from '../FormSectionComponents';
  
const PositionedMoreVert = styled(MoreVert)`  
  &&& {    
    fill: #ccc;
  }
  border-radius: 8px;  
  &&:hover {   
    fill: #999; 
    cursor:pointer;    
  }
`
const StyledTableHead = styled(TableHead)`
  && {
    border-bottom: 3px solid #eee;
  }
`
const ContactInformationTableWrapper = styled(Grid)`
  &&& {
    max-width: 1270px;
    padding-right:20px;
  }
`
const AddContactButton = styled(AddButton)`
  &&& {
    margin-left:0;
    margin-top:8px;
  }
`
const HeaderCell = styled(TableCell)`
  &&& {
    color:#202020;    
  }
`
const OptionsCell = styled(TableCell)`
  &&& {
    display:flex;
    justify-content: flex-end;
    margin-bottom: -1px;
  }
`
const RowOptionsCell = styled(OptionsCell)`
  &&&& {
    height:48px;
    align-items:center;
  }
`
const EmptyContacts = styled.div`
  padding:12px;  
  align-self:stretch;
  background:#f2f2f2;
  color:#999999;
`
const styles = theme => ({
  headerRow: {
    background: '#f9f9f9',
    height:'40px'
  },
  startCell: {
    padding: '8px'
  },
  endCell: {
    padding: '8px'
  },
  iconButton: {   
      maxHeight:'40px', 
      '&:hover': {
        background: 'none'
      }
  }
});

class ContactInformationChildSection extends React.Component {  
  state ={
    isModalOpen:false,
    isDeleteDialogOpen: false,
    selectedCompanyTypeId: null,
    selectedCompanyId: null,
    selectedContactId: null,
    contactIdToRemove: null
  }
  options = [
    { id: 1, value: "Delete", onClick: (optionId, row) => { this.confirmRemove(row.id);} },
  ]
  headerOptions = [
    {id: 1, value: 'Export', onClick: (optionId) => { 
      const loanId = this.props.loanId;
      this.props.exportLoanContacts({id: loanId})}
    }
  ]
  addContact = () => {
    this.setState({
      isModalOpen: true            
    })
  }
  onCancel = () => {
    this.onClose();
  }
  onClose = () => {
    this.setState({
      isModalOpen:false,
      selectedCompanyTypeId: null,
      selectedCompanyId: null,
      selectedContactId: null
    })
  }
  mapContacts = (contacts) => {
    return contacts.map(x => {
      let address = _.get(x, 'contact.address', '--');
      if(!address)
        address = '--'
      let address2 =_.get(x, 'contact.address2','--');
      if(!address2)
        address2 = '--'
      let city = _.get(x, 'contact.city','--');
      if(!city)
        city = '--'
      let state = _.get(x, 'contact.state','--');
      if(!state)
        state = '--'
      let zip = _.get(x, 'contact.zip','--');
      if(!zip)
        zip = '--'
      return {
        id: _.get(x, 'contact.id'),
        contactType:  _.get(x,'contactType.name', ''),
        company: _.get(x, 'contact.company.name', ''),
        name: `${_.get(x, 'contact.firstName', '')} ${_.get(x, 'contact.lastName', '')}`,
        phone: numeral(_.get(x, 'contact.phone')).format('(NNN) NNN-NNNN'),
        email: _.get(x, 'contact.email'),
        address: `${address} ${address2}, ${city}, ${state} ${zip}`
      }
    });   
  }
  remove = (loanContactBridgeId) => {
    this.props.onRemoveContact(loanContactBridgeId);
    this.setState({
      isDeleteDialogOpen:false,
    });
  }
  cancelDeleteContact = () => {
    this.setState({
      isDeleteDialogOpen:false,
      contactIdToRemove: false
    });
  }
  onCompanyTypeChange = val => {
    this.setState({
      selectedCompanyTypeId: val,
      selectedCompanyId: null,
      selectedContactId: null});
  }
  onCompanyChange = val => {
    this.setState({
      selectedCompanyId: val,
      selectedContactId: null});
  }
  onContactChange = val => {
    this.setState({selectedContactId: val})
  }
  openOptionsMenu = (row) => {
    this.setState({
      isOptionsMenuOpen: true
    })
  }
  confirmRemove = (id) => {
    this.setState({
      isDeleteDialogOpen: true,
      contactIdToRemove: id
    })
  }
  buttonRenderer = (isMenuOpen, clickHandler) => {
    const { classes} = this.props;
    return (
      <IconButton classes={{root: classes.iconButton}}>
        <PositionedMoreVert 
          onClick={clickHandler}/>
      </IconButton>
    )
  }
  createRow = (row) => {
    const {isEditing,classes} = this.props;    
    return (
      <TableRow key={row.id}>
        <TableCell classes={{root: classes.startCell}}>{row.contactType}</TableCell>
        <TableCell >{row.company}</TableCell>
        <TableCell >{row.name}</TableCell>
        <TableCell>
          <a href={`tel:${row.phone}`}>{row.phone}</a>
        </TableCell>
        <TableCell>
          <a href={`mailto:${row.email}`}>{row.email}</a>
        </TableCell>
        {!isEditing && <TableCell colSpan={2}>{row.address}</TableCell>}
        {isEditing && <TableCell >{row.address}</TableCell>}        
        {isEditing && <RowOptionsCell>
          <OptionsMenu 
            row={row} 
            buttonRenderer={this.buttonRenderer}
            options={this.options}/>  
          </RowOptionsCell>}        
      </TableRow>
    )
  }

  render(){    
    const {isEditing,formik, classes} = this.props;    
    const contacts = _.get(formik.values, 'loanContacts', []);    
    const mappedContacts = this.mapContacts(contacts);
    const hasContacts = mappedContacts.length > 0;
    const {isModalOpen,contactIdToRemove,isDeleteDialogOpen,
      selectedCompanyTypeId,selectedCompanyId,selectedContactId} = this.state;    
    return (
      <Fragment>
        <div id="loan_section_contact_info">
        <ChildSectionTitle>Contact Information</ChildSectionTitle>
        <ContactInformationTableWrapper container alignItems="flex-start" direction="column">
        {hasContacts && <Table padding='none'>
            <StyledTableHead>
              <TableRow classes={{root:classes.headerRow}}>
                <HeaderCell classes={{root: classes.startCell}}>Contact Type</HeaderCell>
                <HeaderCell >Company</HeaderCell>
                <HeaderCell >Name</HeaderCell>
                <HeaderCell >Phone</HeaderCell>
                <HeaderCell >Email</HeaderCell>
                <HeaderCell >Address </HeaderCell>
                <OptionsCell>
                  <OptionsMenu                      
                    buttonRenderer={this.buttonRenderer}                 
                    options={this.headerOptions}/>  
                </OptionsCell>                
              </TableRow>
            </StyledTableHead>
            <TableBody>
              {mappedContacts.map(row => this.createRow(row))}
            </TableBody>
          </Table>}
          {!hasContacts && <EmptyContacts>There are no contacts</EmptyContacts>}
          {isEditing && <AddContactButton id="addContactButton" onClick={this.addContact} title="Add contact"/>}
          <ContactInformationModalForm 
            onCancel={this.onCancel}
            onClose={this.onClose}
            onSave={this.props.onAddContact}
            onCompanyTypeChange={this.onCompanyTypeChange}
            onCompanyChange={this.onCompanyChange}
            onContactChange={this.onContactChange}
            selectedContactId={selectedContactId}
            loanContacts={mappedContacts}
            selectedCompanyTypeId={selectedCompanyTypeId}
            selectedCompanyId={selectedCompanyId}
            companyTypes={this.props.companyTypes}
            isOpen={isModalOpen}/>
          </ContactInformationTableWrapper>
          <SimpleConfirmDialog
            title="Confirm Delete"
            message="You are about to delete this contact from your list. Are you sure you want to do this?"
            modalOpen={isDeleteDialogOpen}
            handleNo={this.cancelDeleteContact}
            handleYes={() => this.remove(contactIdToRemove)}
            noText="No"
            yesText="Yes, Delete"
           />
        </div>
      </Fragment>
  )};
}

const mapStateToProps = ({  }) => ({
});

export default compose(
  connect,
  reduxConnect(
    mapStateToProps,
    {
      exportLoanContacts,
    }
  ),
  withStyles(styles),
)(ContactInformationChildSection);